import Vue from 'vue';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";

export default {
  name: 'CustomActivity',
  components: {
    datetime: Datetime,
    DateTime,
  },
  props: ['dataObj'],
  data: function () {
    return {
      fieldsGroups: [],
      hasMandatoryFields: false,
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.fieldsGroups.length = 0;

      //categorize fields based on group name
      this.dataObj.appData.forEach(async a => {
        if (a.groupName) {
          if (this.fieldsGroups.length == 0)
            this.fieldsGroups.push({
              groupName: a.groupName,
              data: [],
            });
          else {
            let flag = false;
            this.fieldsGroups.forEach(f => {
              if (f.groupName == a.groupName)
                flag = true;
            })

            if (!flag)
              this.fieldsGroups.push({
                groupName: a.groupName,
                data:[]
              });
          }
        }
      });

      //categorize fields with no group name
      let unamedGrp = this.dataObj.appData.filter(a => !a.groupName);
      if (unamedGrp && unamedGrp.length > 0) {
        this.fieldsGroups.push({
          groupName: this.$t('enquiriesAccount.CustomFields'),
          data: unamedGrp
        })
      }

      //fill groupfields
      this.fieldsGroups.forEach(async f => {
        if (f.groupName != this.$t('enquiriesAccount.CustomFields'))
          f.data = this.dataObj.appData.filter(a => a.groupName == f.groupName);

          //loop through all fields
        f.data.forEach(async d => {
          d['hasError'] = false;

          if (d.isMandatory)
            this.hasMandatoryFields = true;

          this.checkDates(d);

          this.getLookups(d)
            .then(items => {
              d['lookups'] = [...items];
              if (items && items.length > 0)
                this.$forceUpdate();
            })
        });

      });
    },
    checkDates(item) {
      if (item.dateValue.substring(0, 4) == '1899') {
        item.dateValue = '';
      }

      if (item.dateTimeValue.substring(0, 4) == '1899') {
        item.dateTimeValue = '';
      }
    },
    async getLookups(item) {
      if (item.type != 4 && item.type != 5)
        return [];

      return await axios.get('/CustomField/GetLookupValues?lookupId=' + item.typeId)
        .then(resp => {
          if (resp.status == 200) {
            this.loading = false;
            return resp.data;
          }
          else
            return [];
        })
        .catch(err => { return [] });
    },
    validateAppData() {
      let validationFailed = false;
      let firstErrorElem = '';

      this.dataObj.appData.forEach(customField => {
        if (customField.isMandatory) {
          if ((customField.type == 0 && (!customField.strValue)) ||
            (customField.type == 1 && (!customField.intValue || customField.intValue < 0)) ||
            (customField.type == 2 && (!customField.dblValue || customField.dblValue < 0)) ||
            (customField.type == 3 && (!customField.dateValue || isNaN(Date.parse(customField.dateTimeValue)) ) ) ||
            ((customField.type == 4 || customField.type == 5) && !this.validateDropDownSelection(customField)) ||
            (customField.type == 6 && ( !customField.dateTimeValue || isNaN(Date.parse(customField.dateTimeValue)) ) ))
          {
            customField.hasError = true;
            validationFailed = true;

            if (!firstErrorElem)
              firstErrorElem = customField.customFieldId;
          }
          else
            customField.hasError = false;
        }
        else
          customField.hasError = false;
      });

      this.$scrollToElement(firstErrorElem, { behavior: 'smooth', block: 'center', inline: 'center' });
      this.$forceUpdate();

      return !validationFailed;
    },
    validateDropDownSelection(customField) {
      if (!customField.lookups || customField.lookups.length == 0)
        return false;

      let id = customField.dataId;
      let foundFlag = false;

      customField.lookups.forEach(l => {
        if (l.itemId == id)
          foundFlag = true;
      })

      return foundFlag;
    },

    validateField(item) {
      let cssClass = '';

      if (item.isMandatory)
        cssClass = 'background-color-gray_wached';

      if (item.isMandatory && item.hasError)
        cssClass = cssClass + ' md-invalid';

      return cssClass;
      
    }
  },
  
}

